<div class="testimonials-panel">
  <!-- Header -->
  <div class="panel-header">
    <h3 class="panel-title">Testimonials Section</h3>
    <button class="close-btn" (click)="onClose()" aria-label="Close panel">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <div class="segment-control">
      <button 
        class="segment-btn"
        [class.active]="activeTab === 'content'"
        (click)="switchTab('content')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M3 6h12M3 10h12M3 14h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        Content
      </button>
      <button 
        class="segment-btn"
        [class.active]="activeTab === 'layout'"
        (click)="switchTab('layout')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect x="3" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="10" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="3" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="10" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        Layout
      </button>
    </div>
  </div>

  <!-- Content Tab -->
  <div class="panel-content" *ngIf="activeTab === 'content'">
    
    <!-- Heading & Paragraph Section -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('heading')" (click)="toggleSection('heading')">
      <div class="accordion-header">
        <h4 class="section-title">Heading & Paragraph</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('heading')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('heading')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <!-- Heading Input -->
        <div class="form-group">
          <label class="form-label">Heading</label>
          <app-text-editor
            [value]="data.title"
            [style]="data.titleStyle || {}"
            placeholder="Enter heading text..."
            (valueChange)="onHeadingChange($event)"
            (styleChange)="onHeadingStyleChange($event)">
          </app-text-editor>
        </div>

        <!-- Paragraph Input -->
        <div class="form-group">
          <label class="form-label">Paragraph</label>
          <textarea 
            class="paragraph-input"
            [value]="data.subtitle"
            (input)="onSubtitleChange($any($event.target).value)"
            placeholder="Enter paragraph text...">
          </textarea>
        </div>
      </div>
    </div>

    <!-- Testimonial Sections -->
    <div 
      *ngFor="let testimonial of data.testimonials; let i = index; trackBy: trackByIndex"
      class="accordion-section"
      [class.expanded]="isSectionExpanded('testimonial-' + i)"
      (click)="toggleSection('testimonial-' + i)">
      <div class="accordion-header">
        <h4 class="section-title">{{ getTestimonialLabel(i) }}</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('testimonial-' + i)" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('testimonial-' + i)" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <!-- Customer Name -->
        <div class="form-group">
          <label class="form-label">Customer Name</label>
          <input 
            type="text"
            class="form-input"
            [(ngModel)]="testimonial.name"
            (ngModelChange)="onTestimonialChange(i, 'name', $event)"
            placeholder="Enter customer name"/>
        </div>

        <!-- Review Text -->
        <div class="form-group">
          <label class="form-label">Review Text</label>
          <textarea 
            class="form-textarea large"
            [(ngModel)]="testimonial.text"
            (ngModelChange)="onTestimonialChange(i, 'text', $event)"
            placeholder="Enter testimonial text"
            rows="4"></textarea>
        </div>

        <!-- Testimonial Image -->
        <div class="form-group">
          <label class="form-label">Testimonial Image</label>
          <div class="image-upload-section">
            <div class="image-preview-container" [class.has-image]="testimonial.avatar">
              <img 
                *ngIf="testimonial.avatar" 
                [src]="testimonial.avatar" 
                alt="Testimonial image"
                class="testimonial-image">
              <div *ngIf="!testimonial.avatar" class="image-placeholder">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <path d="M24 16C20.6863 16 18 18.6863 18 22C18 25.3137 20.6863 28 24 28C27.3137 28 30 25.3137 30 22C30 18.6863 27.3137 16 24 16Z" fill="#9CA3B0"/>
                  <path d="M24 4C13.5066 4 5 12.5066 5 23C5 33.4934 13.5066 42 24 42C34.4934 42 43 33.4934 43 23C43 12.5066 34.4934 4 24 4ZM24 10C31.1797 10 37 15.8203 37 23C37 30.1797 31.1797 36 24 36C16.8203 36 11 30.1797 11 23C11 15.8203 16.8203 10 24 10Z" fill="#9CA3B0"/>
                </svg>
              </div>
              <!-- Upload loading overlay -->
              <div class="image-overlay" *ngIf="uploadingAvatars[i]" style="background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; position: absolute; top: 0; left: 0; right: 0; bottom: 0; border-radius: 8px;">
                <div style="color: white; text-align: center;">
                  <div style="margin-bottom: 8px;">Uploading...</div>
                  <div style="font-size: 12px;">Please wait</div>
                </div>
              </div>
              <!-- Upload error message -->
              <div class="image-overlay" *ngIf="uploadErrors[i] && !uploadingAvatars[i]" style="background: rgba(220, 38, 38, 0.9); display: flex; align-items: center; justify-content: center; position: absolute; top: 0; left: 0; right: 0; bottom: 0; border-radius: 8px;">
                <div style="color: white; text-align: center; padding: 8px;">
                  <div style="font-size: 12px;">{{ uploadErrors[i] }}</div>
                </div>
              </div>
            </div>
            <div class="image-upload-actions">
              <button type="button" class="replace-btn" (click)="onImageReplaceClick(i)" [disabled]="uploadingAvatars[i]">
                {{ uploadingAvatars[i] ? 'Uploading...' : 'Replace' }}
              </button>
            </div>
            <div class="file-format-info">
              <span class="format-text">Accepted formats - .png, .jpg, .jpeg</span>
              <span class="divider">|</span>
              <span class="format-text">Max file size - 5MB</span>
            </div>
            <input 
              type="file"
              [id]="'testimonial-image-' + i"
              class="file-input"
              accept="image/png,image/jpeg,image/jpg"
              (change)="onImageFileSelected(i, $event)"
              style="display: none;">
          </div>
        </div>

      </div>
    </div>

    <!-- Card Color Section -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('cardStyle')" (click)="toggleSection('cardStyle')">
      <div class="accordion-header">
        <h4 class="section-title">Card Color</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('cardStyle')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('cardStyle')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <!-- Color Swatches -->
        <div class="color-palette">
          <div class="color-list">
            <!-- Purple Color -->
            <div class="color-item" [class.selected]="data.cardColor === '#5E19A1'" (click)="onCardColorChange('#5E19A1')">
              <div class="color-swatch" style="background-color: #5E19A1;"></div>
              <span class="color-code">#5E19A1</span>
              <div class="checkmark" *ngIf="data.cardColor === '#5E19A1'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Orange Color -->
            <div class="color-item" [class.selected]="data.cardColor === '#FF9736'" (click)="onCardColorChange('#FF9736')">
              <div class="color-swatch" style="background-color: #FF9736;"></div>
              <span class="color-code">#FF9736</span>
              <div class="checkmark" *ngIf="data.cardColor === '#FF9736'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Green Color -->
            <div class="color-item" [class.selected]="data.cardColor === '#079271'" (click)="onCardColorChange('#079271')">
              <div class="color-swatch" style="background-color: #079271;"></div>
              <span class="color-code">#079271</span>
              <div class="checkmark" *ngIf="data.cardColor === '#079271'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Blue Color -->
            <div class="color-item" [class.selected]="data.cardColor === '#1B5BFF'" (click)="onCardColorChange('#1B5BFF')">
              <div class="color-swatch" style="background-color: #1B5BFF;"></div>
              <span class="color-code">#1B5BFF</span>
              <div class="checkmark" *ngIf="data.cardColor === '#1B5BFF'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
          
          <!-- Divider -->
          <div class="color-divider"></div>
          
          <!-- Add Color Button -->
          <div class="add-color-section">
            <div class="color-item add-color" (click)="onAddCardColor()">
              <div class="color-swatch add-color-swatch">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M6 1V11M1 6H11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="color-code">Add Color</span>
            </div>
          </div>

          <!-- Custom Colors (dynamically added) -->
          <div class="color-item" 
               *ngFor="let customColor of cardCustomColors; trackBy: trackByIndex" 
               [class.selected]="data.cardColor === customColor" 
               (click)="openCardColorPicker(customColor)">
            <div class="color-swatch" [style.background-color]="customColor"></div>
            <span class="color-code">{{ customColor }}</span>
            <div class="checkmark" *ngIf="data.cardColor === customColor">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Background Section -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('background')" (click)="toggleSection('background')">
      <div class="accordion-header">
        <h4 class="section-title">Background</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('background')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      
      <div class="accordion-content" *ngIf="isSectionExpanded('background')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <!-- Color Swatches -->
        <div class="color-palette">
          <div class="color-list">
            <!-- Purple Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#5E19A1'" (click)="onBackgroundColorChange('#5E19A1')">
              <div class="color-swatch" style="background-color: #5E19A1;"></div>
              <span class="color-code">#5E19A1</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#5E19A1'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Orange Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#FF9736'" (click)="onBackgroundColorChange('#FF9736')">
              <div class="color-swatch" style="background-color: #FF9736;"></div>
              <span class="color-code">#FF9736</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#FF9736'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Green Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#079271'" (click)="onBackgroundColorChange('#079271')">
              <div class="color-swatch" style="background-color: #079271;"></div>
              <span class="color-code">#079271</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#079271'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            
            <!-- Blue Color -->
            <div class="color-item" [class.selected]="data.backgroundColor === '#1B5BFF'" (click)="onBackgroundColorChange('#1B5BFF')">
              <div class="color-swatch" style="background-color: #1B5BFF;"></div>
              <span class="color-code">#1B5BFF</span>
              <div class="checkmark" *ngIf="data.backgroundColor === '#1B5BFF'">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
          
          <!-- Divider -->
          <div class="color-divider"></div>
          
          <!-- Add Color Button -->
          <div class="add-color-section">
            <div class="color-item add-color" (click)="onAddColor()">
              <div class="color-swatch add-color-swatch">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M6 1V11M1 6H11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="color-code">Add Color</span>
            </div>
          </div>

          <!-- Custom Colors (dynamically added) -->
          <div class="color-item" 
               *ngFor="let customColor of customColors; trackBy: trackByIndex" 
               [class.selected]="data.backgroundColor === customColor" 
               (click)="openColorPicker(customColor)">
            <div class="color-swatch" [style.background-color]="customColor"></div>
            <span class="color-code">{{ customColor }}</span>
            <div class="checkmark" *ngIf="data.backgroundColor === customColor">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3L4.5 8.5L2 6" stroke="#079271" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- Background Color Picker Modal -->
  <div class="color-picker-overlay" *ngIf="isColorPickerOpen" (click)="closeColorPicker()">
    <div class="color-picker-modal" (click)="$event.stopPropagation()">
      <div class="color-picker-header">
        <h3 class="color-picker-title">Color picker</h3>
        <button class="color-picker-close" (click)="closeColorPicker()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M11 1L1 11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="color-picker-content">
        <chrome-picker 
          [(color)]="currentPickerColor"
          (colorChange)="onColorPickerChange()">
        </chrome-picker>
      </div>
    </div>
  </div>

  <!-- Card Color Picker Modal -->
  <div class="color-picker-overlay" *ngIf="isCardColorPickerOpen" (click)="closeCardColorPicker()">
    <div class="color-picker-modal" (click)="$event.stopPropagation()">
      <div class="color-picker-header">
        <h3 class="color-picker-title">Color picker</h3>
        <button class="color-picker-close" (click)="closeCardColorPicker()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 1L11 11M11 1L1 11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="color-picker-content">
        <chrome-picker 
          [(color)]="currentCardPickerColor"
          (colorChange)="onCardColorPickerChange()">
        </chrome-picker>
      </div>
    </div>
  </div>

  </div>

  <!-- Layout Tab -->
  <div class="panel-content" *ngIf="activeTab === 'layout'">
    <div class="empty-state">
      <p>Layout options coming soon...</p>
    </div>
  </div>
</div>

